import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import FormItemContainer from '../../Global/Containers/FormItemContainer';
import Button from '@material-ui/core/Button';
import ButtonStyles from '../../../styles/button';
import classnames from 'classnames';
import combineStyles from '../../../utils/combineStyles';
import SpacingStyles from '../../../styles/helpers/spacing';

import ActivityList from './ActivityList';
import ActivityModal from './ActivityModal';
import moment from 'moment';

const styles = theme => ({
  activityLogButton: {
    marginBottom: 0,
    marginTop: theme.spacing.unit * 2
  }
});
export class Activity extends PureComponent {
  static propTypes = {
    activities: PropTypes.array.isRequired
  };
  state = {
    activityModalOpen: false
  };
  _openActivityModal = () => {
    this.setState({ activityModalOpen: true });
  };
  _closeActivityModal = () => {
    this.setState({ activityModalOpen: false });
  };
  render() {
    const { t, classes, activities } = this.props;
    const sortedActivities = [...activities].sort(
      (a, b) => moment(b.createdUtc) - moment(a.createdUtc)
    );
    const displayedActivities = sortedActivities.slice(0, 2);
    return (
      <FormItemContainer title={t('Activity')}>
        <ActivityList activities={displayedActivities} />
        <Button
          variant="outlined"
          color="primary"
          className={classnames(classes.outlinedButton, classes.noMarginBottom)}
          classes={{ label: classes.buttonLabel }}
          onClick={this._openActivityModal}
        >
          {t('View Activity Log')}
        </Button>
        <ActivityModal
          open={this.state.activityModalOpen}
          onClose={this._closeActivityModal}
          activities={sortedActivities}
        />
      </FormItemContainer>
    );
  }
}
const translatedActivity = withNamespaces()(Activity);
export default withStyles(combineStyles(ButtonStyles, SpacingStyles, styles))(
  translatedActivity
);
